import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import SearchTable from '../../../../../../../../../../components/search/SearchTable';
import { buildQuickFilterOptions, setAdvancedFilterValues } from '../../../../../../../../../../components/search/util';
import { itemSearch } from '../../../../../../../../../../redux/modules/items';
import { useCompanyCodes, useCompanyItemTypesData } from '../../../../../../../../../../services/company-service';

import advancedFilters from './filters/advancedFilters';
import quickFilters from './filters/quickFilters';
import { buildItemColumns, generateItemsTableDefaultColumns } from './util';

const ItemTable = ({ companyId, insuredId, jobId }) => {
  const dispatch = useDispatch();
  const { data: itemTypes, isLoading: itemTypesLoading } = useCompanyItemTypesData(companyId);
  const { data: companyCodes, isLoading: companyCodesLoading } = useCompanyCodes(companyId);

  const defaultColumns = useMemo(() => generateItemsTableDefaultColumns(companyId, insuredId), [companyId]);

  useEffect(() => {
    if (itemTypesLoading || companyCodesLoading) return;

    const { itemTypeProperties = [] } = itemTypes.find(type => type.name === 'unit') || {};
    const globalSearchIndices = itemTypeProperties.map(p => `property_values.${p.name}`);

    dispatch(itemSearch.setBaseFilters([
      { key: 'insured.id', value: insuredId },
      { key: 'job.id', value: jobId }
    ]));

    dispatch(itemSearch.setGlobalSearchIndicies(globalSearchIndices));
    dispatch(itemSearch.updateSortBy([{ id: 'unit_number', desc: true }]));

    dispatch(itemSearch.setQuickFilterOptions(buildQuickFilterOptions(quickFilters, { codeApplied: companyCodes })));

    dispatch(itemSearch.setAdvancedFilterOptions(advancedFilters));

    const companyCodeOptions = companyCodes.map(({ letter }) => ({
      text: letter,
      value: letter
    }));

    dispatch(itemSearch.setAdvancedFilterOptions(setAdvancedFilterValues(advancedFilters, { codes: { subProperty: 'letter', values: companyCodeOptions } })));

    dispatch(itemSearch.setColumns(
      buildItemColumns(itemTypeProperties)
        .concat(defaultColumns)
        .sort((a, b) => a.order - b.order)
    ));

    dispatch(itemSearch.getPage());
  }, [companyCodes, itemTypes, insuredId, jobId]);

  return (
    <SearchTable searchBlueprint={itemSearch} />
  );
};

ItemTable.propTypes = {
  companyId: PropTypes.number.isRequired,
  insuredId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired
};

export default ItemTable;
